import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';
import type {
  DeleteResult,
  EntranteDto,
  EntranteUpsert,
  OpensipsReloadResult,
  PreviewResult,
  SalienteDto,
  SalienteUpsert,
  SetCapacityInput,
  WriteResult
} from './opensips.types';

const SAL = `${API_ENDPOINT.CORE}salientes`;
const ENT = `${API_ENDPOINT.CORE}entrantes`;
const dry = { params: { dryRun: 'true' } };

/**
 * Salientes = tabla `load_balancer` de OpenSIPS (137.184.186.26) · Entrantes = tabla `address`.
 * Los métodos `preview*` mandan `?dryRun=true` y devuelven la fila sin escribir.
 * Los métodos de escritura disparan el reload MI y devuelven `{ record, reload }`.
 */
export const RoutesService = {
  // ----- Salientes ----------------------------------------------------------
  getOutgoing: (groupId?: number) =>
    HTTP.get<SalienteDto[], SalienteDto[]>(
      SAL,
      groupId !== undefined ? { params: { groupId } } : undefined
    ),
  getOutgoingById: (id: string | number) => HTTP.get<SalienteDto, SalienteDto>(`${SAL}/${id}`),
  previewCreateOutgoing: (data: SalienteUpsert) =>
    HTTP.post<PreviewResult, PreviewResult>(SAL, data, dry),
  createOutgoing: (data: SalienteUpsert) =>
    HTTP.post<WriteResult<SalienteDto>, WriteResult<SalienteDto>>(SAL, data),
  previewUpdateOutgoing: (id: string | number, data: SalienteUpsert) =>
    HTTP.put<PreviewResult, PreviewResult>(`${SAL}/${id}`, data, dry),
  updateOutgoing: (id: string | number, data: SalienteUpsert) =>
    HTTP.put<WriteResult<SalienteDto>, WriteResult<SalienteDto>>(`${SAL}/${id}`, data),
  previewCapacity: (id: string | number, data: SetCapacityInput) =>
    HTTP.put<PreviewResult, PreviewResult>(`${SAL}/${id}/capacity`, data, dry),
  setCapacity: (id: string | number, data: SetCapacityInput) =>
    HTTP.put<WriteResult<SalienteDto>, WriteResult<SalienteDto>>(`${SAL}/${id}/capacity`, data),
  deleteOutgoing: (id: string) => HTTP.delete<DeleteResult, DeleteResult>(`${SAL}/${id}`),
  /** lb_reload (solo rol admin en el backend) */
  reloadOutgoing: () => HTTP.post<OpensipsReloadResult, OpensipsReloadResult>(`${SAL}/reload`, {}),

  // ----- Entrantes ----------------------------------------------------------
  getIncoming: () => HTTP.get<EntranteDto[], EntranteDto[]>(ENT),
  getIncomingById: (id: string | number) => HTTP.get<EntranteDto, EntranteDto>(`${ENT}/${id}`),
  previewCreateIncoming: (data: EntranteUpsert) =>
    HTTP.post<PreviewResult, PreviewResult>(ENT, data, dry),
  createIncoming: (data: EntranteUpsert) =>
    HTTP.post<WriteResult<EntranteDto>, WriteResult<EntranteDto>>(ENT, data),
  previewUpdateIncoming: (id: string | number, data: EntranteUpsert) =>
    HTTP.put<PreviewResult, PreviewResult>(`${ENT}/${id}`, data, dry),
  updateIncoming: (id: string | number, data: EntranteUpsert) =>
    HTTP.put<WriteResult<EntranteDto>, WriteResult<EntranteDto>>(`${ENT}/${id}`, data),
  deleteIncomming: (id: string) => HTTP.delete<DeleteResult, DeleteResult>(`${ENT}/${id}`),
  /** address_reload (supervisor/admin) */
  reloadIncoming: () => HTTP.post<OpensipsReloadResult, OpensipsReloadResult>(`${ENT}/reload`, {})
};
